<template>
  <el-dialog :visible.sync="formVisible" :close-on-click-modal="false" width="1000px" top="10vh" class="approve-dialog"
    @close="handleClose">
    <div slot="title" class="dialog-title">
      <img src="../../../assets/icon-green.png" alt="approve" class="title-icon" />
      <div class="title-content">
        <div class="title-main">同意申请</div>
        <div class="title-sub">终审审核完成才生效</div>
      </div>
    </div>
    <div class="dialog-body" v-if="currentRow">
      <div class="detail-box">
        <div class="detail-item">
          <span class="label">用户信息：</span>
          <span class="value">{{ currentRow.customerName }} - {{ currentRow.currentLevelName }} - {{
            currentRow.customerPho }}</span>
        </div>
        <div class="detail-item">
          <span class="label">用户所属城市公司：</span>
          <span class="value">{{ currentRow.customerPO.cityCompanyName}}</span>
        </div>
        <div class="detail-item">
          <span class="label">提交来源：</span>
          <span class="value">{{ getApplySource(currentRow) }}</span>
        </div>
        <div class="detail-item">
          <span class="label">申请类型：</span>
          <span class="value">{{ getApplyType(currentRow) }}</span>
        </div>
        <div class="detail-item" v-if="currentRow.registrationType<10">
          <span class="label">报名费用：</span>
          <span class="value">{{ currentRow.fee }}</span>
        </div>
      </div>
      <div class="gift-box" v-if="currentRow.giftCombineName">
        <div class="detail-item">
          <span class="label">赠送礼包：</span>
          <span class="value">{{ currentRow.giftCombineName }}</span>
        </div>
      </div>
      <intent-registration-credit :registration-id="currentRow.id" />
      <!-- 付款凭证信息 -->
      <template v-if="currentRow.payPOList && currentRow.payPOList.length > 0">
        <div class="voucher-box">
          <div class="detail-item">
            <span class="label">付款凭证：</span>
            <span class="value">报名金额{{ currentRow.fee }}元</span>
          </div>
          <el-form ref="payForm" :model="form" class="pay-form" label-width="0">
            <div class="voucher-item" v-for="(item, index) in form.payPOList" :key="index">
              <div class="pay-img">
                <el-image :src="item.payImg" style="width: 100px; height: 100px;" :preview-src-list="form.payPOList.map(p => p.payImg)" />
                <!-- 仅 state === -1 时显示删除按钮 -->
                <div class="pay-img-actions" v-if="currentRow.state === -1">
                  <i class="el-icon-delete" @click="handleDeleteVoucher(item, index)"></i>
                </div>
              </div>
              <div class="pay-info">
                <!-- 仅 state === -1 时显示操作按钮 -->
                <div class="pay-actions" v-if="currentRow.state === -1">
                  <el-button v-if="!item.ocrContent" type="primary" size="mini" class="pay-action-btn"
                    @click="getOcrTest(index)">
                    OCR提取文字
                  </el-button>
                  <el-popover v-else placement="top-start" title="" width="400" trigger="hover"
                    :content="item.ocrContent">
                    <el-button slot="reference" size="mini" class="pay-action-btn">查看OCR信息</el-button>
                  </el-popover>
                  <el-button type="primary" @click="handleAddItem(item)" size="small">复制凭证</el-button>
                </div>
                <div class="pay-grid">
                  <div style="display: flex; align-items: center; gap: 8px;">
                    <el-form-item :prop="'payPOList.' + index + '.payBank'"
                      :rules="currentRow.state === -1 ? { required: true, message: '请选择收款银行', trigger: 'change' } : []" class="pay-field" style="flex: 1; margin-bottom: 0;">
                      <el-select v-model="item.payBank" placeholder="请选择收款银行" filterable :disabled="currentRow.state !== -1">
                        <el-option v-for="(it, idx) in visibleBankOptions" :key="idx" :label="it.bankName"
                          :value="it.bankName" />
                      </el-select>
                    </el-form-item>
                    <el-button v-if="currentRow.state === -1" type="text" @click="toggleBankFilter" style="padding: 0; white-space: nowrap;">
                      {{ showAllBanks ? '按城市过滤' : '全部' }}
                    </el-button>
                  </div>

                  <el-form-item :prop="'payPOList.' + index + '.payNum'"
                    :rules="currentRow.state === -1 ? { required: true, message: '请输入支付单号', trigger: 'blur' } : []" class="pay-field">
                    <el-input v-model="item.payNum" placeholder="请输入支付单号" :disabled="currentRow.state !== -1" />
                  </el-form-item>

                  <el-form-item :prop="'payPOList.' + index + '.payMoney'"
                    :rules="currentRow.state === -1 ? { required: true, message: '请输入付款金额', trigger: 'blur' } : []" class="pay-field">
                    <el-input v-model="item.payMoney" placeholder="请输入付款金额" :disabled="currentRow.state !== -1" />
                  </el-form-item>

                  <el-form-item :prop="'payPOList.' + index + '.payTime'"
                    :rules="currentRow.state === -1 ? { required: true, message: '请选择付款日期', trigger: 'change' } : []" class="pay-field">
                    <el-date-picker v-model="item.payTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
                      placeholder="付款日期" :disabled="currentRow.state !== -1" />
                  </el-form-item>

                  <el-form-item :prop="'payPOList.' + index + '.payMethod'"
                    :rules="currentRow.state === -1 ? { required: true, message: '请选择付款方式', trigger: 'change' } : []" class="pay-field">
                    <el-select v-model="item.payMethod" placeholder="请选择付款方式" :disabled="currentRow.state !== -1">
                      <el-option label="扫码支付" :value="1"></el-option>
                      <el-option label="银行转账" :value="2"></el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
            </div>

            <div class="detail-item">
              <span class="label">赠送金额：</span>
              <el-input
                v-model="form.upgradeGiftAmount"
                placeholder="请输入赠送金额"
                :disabled="currentRow.state !== -1"
                @input="handleGiftAmountInput"
                @blur="handleGiftAmountBlur"
              />
            </div>
          </el-form>
        </div>
      </template>
      <!-- 附件信息 -->
      <div class="voucher-box" v-if="currentRow.applyVoucher">
        <div class="detail-item">
          <span class="label">附件：</span>
          <div class="voucher-imgs">
            <el-image v-for="(img, idx) in currentRow.applyVoucher.split(',')" :key="idx"
              style="width: 60px; height: 60px; margin-right: 8px;" :src="img"
              :preview-src-list="currentRow.applyVoucher.split(',')" />
          </div>
        </div>
      </div>
      <div class="voucher-box" v-if="currentRow.content">
        <div class="detail-item">
          <span class="label">申请原因：</span>
          <span class="value">{{ currentRow.content }}</span>
        </div>
      </div>

      <div class="applicant-info">
        <div class="detail-item">
          <span class="label">申请人：</span>
          <span class="value">{{ currentRow.realName }} - {{ currentRow.operatedRoleName }} - {{ currentRow.userPho
          }}</span>
        </div>
        <div class="detail-item">
          <span class="label">提交时间：</span>
          <span class="value">{{ currentRow.createdTime || '-' }}</span>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">取消</el-button>
      <el-button type="primary" @click="doApprove" :loading="isLoading">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import rechargeRecordApi from '@/api/recharge/rechargeRecord'
import sysDataconstantApi from '@/api/config/sysDataconstant'
import customerRegistrationPayApi from '@/api/cust/customerRegistrationPay'
import customerRegistrationApi from '@/api/cust/customerRegistration'
import IntentRegistrationCredit from '@/components/IntentDeposit/RegistrationCredit'
export default {
  components: { IntentRegistrationCredit },
  data() {
    return {
      formVisible: false,
      isLoading: false,
      currentRow: null,
      sectionList: [],
      form: {
        payPOList: [],
        upgradeGiftAmount: ''
      },
      showAllBanks: false
    }
  },
  computed: {
    enabledSectionList() {
      return (this.sectionList || []).filter(it => String(it.isEnable) === '1')
    },
    filteredSectionList() {
      if (!this.sectionList) {
        return []
      }
      const enabled = this.sectionList.filter(it => String(it.isEnable) === '1')
      // 优先从 customerPO 获取城市公司ID，其次从 currentRow 直接获取
      let selectedCityCompanyId = null
      if (this.currentRow && this.currentRow.customerPO && this.currentRow.customerPO.cityCompanyId) {
        selectedCityCompanyId = this.currentRow.customerPO.cityCompanyId
      } else if (this.currentRow && this.currentRow.cityCompanyId) {
        selectedCityCompanyId = this.currentRow.cityCompanyId
      }
      
      if (selectedCityCompanyId !== undefined && selectedCityCompanyId !== null && selectedCityCompanyId !== '') {
        const ccIdNum = Number(selectedCityCompanyId)
        return enabled.filter(it => Number(it.cityId) === ccIdNum)
      }
      return enabled
    },
    visibleBankOptions() {
      const enabled = (this.sectionList || []).filter(it => String(it.isEnable) === '1')
      return this.showAllBanks ? enabled : this.filteredSectionList
    }
  },
  created() {
    this.getConfig();
  },
  methods: {
    handleGiftAmountInput(val) {
      const value = String(val == null ? '' : val)
      // 仅保留数字和小数点，并限制为最多两位小数
      const sanitized = value
        .replace(/[^\d.]/g, '')
        .replace(/^\./, '')
        .replace(/\.{2,}/g, '.')
        .replace('.', '$#$')
        .replace(/\./g, '')
        .replace('$#$', '.')
        .replace(/^(\d+)\.(\d{0,2}).*$/, '$1.$2')
      if (sanitized !== this.form.upgradeGiftAmount) {
        this.form.upgradeGiftAmount = sanitized
      }
    },
    handleGiftAmountBlur() {
      if (this.form.upgradeGiftAmount === '' || this.form.upgradeGiftAmount == null) return
      const num = Number(this.form.upgradeGiftAmount)
      if (!Number.isFinite(num) || num <= 0) {
        this.$message.warning('赠送金额需大于0，最多两位小数')
        this.form.upgradeGiftAmount = ''
      }
    },
    isValidGiftAmount() {
      if (this.currentRow.state !== -1) return true
      const val = String(this.form.upgradeGiftAmount == null ? '' : this.form.upgradeGiftAmount).trim()
      if (!val) return true
      const reg = /^(?:0\.\d{1,2}|[1-9]\d*(?:\.\d{1,2})?)$/
      if (!reg.test(val) || Number(val) <= 0) {
        this.$message.warning('赠送金额需大于0，最多两位小数')
        return false
      }
      return true
    },
    toggleBankFilter() {
      this.showAllBanks = !this.showAllBanks
    },
    handleCreate(row) {
      const payPOList = (row.payPOList || []).map(item => ({
        ...item,
        payMethod: item.payMethod || null
      }))
      this.currentRow = {
        ...row,
        payPOList
      }
      this.form = {
        payPOList,
        upgradeGiftAmount: row.upgradeGiftAmount
      }
      this.showAllBanks = false
      this.formVisible = true
    },
    handleClose() {
      this.currentRow = null
      this.form = {
        payPOList: [],
        upgradeGiftAmount: ''
      }
      this.showAllBanks = false
    },
    // 获取系统配置
    getConfig() {
      sysDataconstantApi.fetchBatchCode({
        code: 'lineUpMoneyBankType'
      }).then(({
        data
      }) => {
        this.sectionList = data.list[0].content ? JSON.parse(data.list[0].content) : []
      })
    },
    formatUserInfo(row) {
      if (!row) return '-'
      if (row.targetUserName && row.targetUserLevelName && row.targetUserMobile) {
        return `${row.targetUserName}-${row.targetUserLevelName}-${row.targetUserMobile}`
      }
      return row.userInfo || '-'
    },
    formatApplicantInfo(row) {
      if (!row) return '-'
      if (row.applicantName && row.applicantLevelName && row.applicantMobile) {
        return `${row.applicantName}-${row.applicantLevelName}-${row.applicantMobile}`
      }
      return row.applicantInfo || '-'
    },
    getApplySource(row) {
      if (!row) return '-'
      if (row.dataSource === 1) return 'app业务员提交'
      if (row.dataSource === 2) return '管理后台提交'
      if (row.dataSource === 3) return 'app客户申请'
      if (row.dataSource === 4) return '管理后台导入'
      return '-'
    },
    getApplyType(row) {
      if (!row) return '-'
      if (row.registrationType === 1) return '普通人员升级研修班'
      if (row.registrationType === 2) return '普通人员升级体验班'
      if (row.registrationType === 3) return '体验班升级研修班'
      //10|体降普，20|研降普
      if (row.registrationType === 10) return '体验班降级为普通人员'
      if (row.registrationType === 20) return '研修班降级为普通人员'
      if (row.registrationType === 30) return '研修班降级为体验班'
      return '-'
    },
    getVoucherImages(row) {
      if (!row) return []
      if (row.imgUrl) {
        return row.imgUrl.split(',').filter(Boolean)
      }
      return []
    },
    doApprove() {
      if (!this.currentRow || !this.currentRow.id) {
        this.$message.error('数据异常')
        return
      }
      if (!this.isValidGiftAmount()) {
        return
      }
      const proceed = () => {
        this.$confirm('是否确认同意申请', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
          // 获取第一个支付凭证的银行信息（初审和终审都需要）
          let bankNum = ''
          if (this.form.payPOList && this.form.payPOList.length > 0) {
            const firstPayBank = this.form.payPOList.find(item => item.payBank)
            if (firstPayBank && firstPayBank.payBank) {
              bankNum = firstPayBank.payBank
            }
          }

          if (this.currentRow.state === -1) {
            this.isLoading = true
          
          // 如果有支付凭证列表，先调用setPayNum接口保存支付信息
          if (this.form.payPOList && this.form.payPOList.length > 0) {
            const payNumData = this.form.payPOList.map(item => ({
              dataType: item.dataType || 0,
              id: item.id,
              ocrContent: item.ocrContent || '',
              payBank: item.payBank || '',
              payImg: item.payImg || '',
              payMethod: item.payMethod || null,
              payMoney: item.payMoney || 0,
              payNum: item.payNum || '',
              payTime: item.payTime || '',
              registrationId: item.registrationId || this.currentRow.id,
              state: 1
            }))
          
            console.log('调用setPayNum接口，数据:', payNumData)
            customerRegistrationApi.setPayNum(payNumData).then(() => {
             
              // 调用成功后再触发approve事件
              this.$emit('approve', { 
                id: this.currentRow.id, 
                isPass: true,
                bankNum: bankNum,
                upgradeGiftAmount: this.form.upgradeGiftAmount || 0
              }, this.handleApproveCallback)
            }).catch(err => {
              console.error('setPayNum失败:', err)
              this.$message.error('保存支付信息失败: ' + (err.message || ''))
              this.isLoading = false
            })
          } else {
            // 没有支付凭证，直接触发approve事件
        
            this.$emit('approve', { 
              id: this.currentRow.id, 
              isPass: true,
              bankNum: bankNum,
              upgradeGiftAmount: this.form.upgradeGiftAmount || 0
            }, this.handleApproveCallback)
          }
        } else {
      
            // 终审：直接调用 agreeOrReject 接口
            this.isLoading = true
            customerRegistrationApi.agreeOrReject({
              id: this.currentRow.id,
              version:2,
              state: 1,
              bankNum: bankNum,
              upgradeGiftAmount: this.form.upgradeGiftAmount || 0
            }).then(res => {
              if (res.code === '0') {
                this.$message.success('终审同意成功')
                this.$emit('refresh')
                this.formVisible = false
              } else {
                this.$message.error(res.msg || '操作失败')
              }
              this.isLoading = false
            }).catch(err => {
              this.$message.error('操作失败: ' + (err.message || ''))
              this.isLoading = false
            }).finally(() => {
              this.isLoading = false
            })
          }
        }).catch(() => { })
      }

      // 降级或没有支付表单，直接执行
      proceed()
    },
    /**
     * 识别支付单号
     */
    getOcrTest(index) {
      if (!this.form || !this.form.payPOList || !this.form.payPOList[index]) {
        return
      }
      const target = this.form.payPOList[index]
      return rechargeRecordApi.accurateOCR({ imageUrl: target.payImg })
        .then(res => {
          this.$set(this.form.payPOList[index], 'ocrContent', res.data)
          this.$forceUpdate()
        })
    },
    handleDeleteVoucher(item, index) {
      this.$confirm('确认删除该凭证信息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 调用删除接口
        customerRegistrationPayApi.deleteById(item.id).then(res => {
          if (res.code === '0') {
            this.form.payPOList.splice(index, 1)
            this.currentRow.payPOList = this.form.payPOList
            this.$message.success('删除成功')
          }
        })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
    handleAddItem(item) {
      this.$confirm('确认复制当前凭证信息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 调用接口获取数据
        customerRegistrationPayApi.create({ state: 0, payImg: item.payImg, registrationId: item.registrationId, dataType: item.dataType }).then(res => {
          if (res.code === '0') {
            const obj = res.data;
            obj.payBank = ""
            obj.payMoney = ""
            obj.payTime = ""
            this.form.payPOList.push(obj)
            this.currentRow.payPOList = this.form.payPOList
            this.$message.success('复制成功')
          }
        })
      }).catch(() => {
        this.$message.info('已取消复制')
      })
    },
    handleApproveCallback() {
      this.isLoading = false
      this.formVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.approve-dialog ::v-deep .el-dialog__header {
  padding: 20px 20px 10px;
}

.approve-dialog ::v-deep .el-dialog__body {
  padding: 10px 20px 20px;
}

.dialog-title {
  display: flex;
  gap: 20px;
  align-items: center;

  .title-icon {
    width: 60px;
  }

  .approve-icon {
    color: #67c23a;
  }

  .title-content {
    .title-main {
      font-size: 18px;
      color: #000000;
    }

    .title-sub {
      font-size: 14px;
      color: #8F8E8E;
      padding-top: 10px;
    }
  }
}

.detail-box {
  background: #F8F8F8;
  border-radius: 4px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  .detail-item {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    font-size: 16px;
    line-height: 14px;

    &:last-child {
      margin-bottom: 0;
    }

    .label {
      color: #666666;
      display: inline-block;
      flex-shrink: 0;
    }

    .value {
      color: #6C6C6C;
    }

    .voucher-imgs {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
    }
  }
}

.gift-box {
  margin-top: 10px;
  padding: 20px 8px;
  border-radius: 4px;
  background-color: #F8F8F8;

  .detail-item {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 16px;
    color: #666666;
  }
}

.voucher-box {
  margin-top: 10px;
  padding: 20px 8px;
  border-radius: 4px;
  background-color: #F8F8F8;

  .detail-item {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 16px;
    color: #666666;

    .label {
      flex-shrink: 0;
    }
  }

  .pay-form {
    padding-top: 20px;
  }

  .voucher-imgs {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }

  .voucher-item {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 10px 0;

    .pay-img {
      position: relative;

      .pay-img-actions {
        position: absolute;
        right: 0;
        left: 0;
        bottom: 0;
        height: 26px;
        background-color: #C5C5C5;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 0 4px 0 4px;

        .el-icon-delete {
          color: #E73F3F;
          cursor: pointer;
          font-size: 16px;
        }
      }
    }

    &:first-child {
      padding-top: 0;
    }

    &:last-child {
      border-bottom: none;
      padding-bottom: 0;
    }
  }

  .pay-actions {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }

  .pay-action-btn {
    width: 120px;
  }

  .pay-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 12px;
    row-gap: 10px;

    ::v-deep .el-form-item {
      margin-bottom: 0;
    }

    ::v-deep .el-form-item__error {
      position: static;
      padding-top: 2px;
      line-height: 1.2;
    }

    ::v-deep .el-form-item__content,
    ::v-deep .el-select,
    ::v-deep .el-input,
    ::v-deep .el-date-editor {
      width: 100%;
    }
  }

  @media screen and (max-width: 768px) {
    .pay-grid {
      grid-template-columns: 1fr;
    }

    .pay-action-btn {
      width: 100%;
    }
  }
}

.applicant-info {
  display: flex;
  padding: 20px;
  flex-direction: column;
  gap: 20px;
  font-size: 16px;
  color: #666666;

  .detail-item {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 16px;
    color: #666666;

    .label,
    .value {
      color: #666666;
    }
  }
}
</style>
